/**
 * Query keys for user chat data.
 */
export const userChatKeys = {
  all: ['user-chat'] as const,
  primaryByUser: (userId: string) => ['user', userId, 'chat', 'primary'] as const,
};
